module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarReporteBoletasPendientes) ? _c('div', {
    key: "reporte_boletas",
    staticClass: "box position-relative"
  }, [_c('lista-boletas-pendientes', {
    on: {
      "close": function($event) {
        _vm.mostrarReporteBoletasPendientes = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e37bc1e4","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Boletas_Pendientes_Generar.vue
// module id = 964
// module chunks = 0